import React, { useEffect, useState, useContext, useCallback } from "react";
import moment from "moment";
import styled from "styled-components";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import { get } from "../../server-requests/serverRequests";
import { AuthContext } from "../authContextProvider";
import { getTranslation } from "../languageProvider";
import { Log } from "../shared/utility";
import DatePickerHooksReport from "../shared/datePickerHooksReport";

export const PointsReport = ({ point }) => {
  const { snackbarHandler } = useContext(AuthContext);

  const [isLoadPointsRepairsList, setIsLoadPointsRepairsList] = useState(true);
  const [pointsRepairsList, setPointsRepairsList] = useState([]);

  const [isLoadObservationsText, setIsLoadObservationsText] = useState(true);
  const [observationsText, setObservationsText] = useState([]);

  const [vehicle, setVehicle] = useState([]);

  const [isLoadOImages, setIsLoadOImages] = useState(true);
  const [images, setImages] = useState([]);
  const [removeRouteDate, setRemoveRouteDate] = useState(false);

  const [hideTimeline, setHideTimeline] = useState({
    S: true,
    M: true,
    E: true,
  });

  const [startedPoint, setStartedPoint] = useState(
    point.started ? point.started : ""
  );
  const [endedPoint, setEndedPoint] = useState(point.ended ? point.ended : "");

  // get vehicle

  useEffect(() => {
    let isMounted = true;
    get("routes/vehicles/list", { routeId: point.routeId })
      .then((list) => {
        if (isMounted) setVehicle(list);
      })
      .catch((status) => {
        snackbarHandler(getTranslation(`error${status}`));
        Log("Error on get routes/vehicles/list" + status);
      });
    return () => (isMounted = false);
  }, [point.routeId, snackbarHandler]);

  // get images
  useEffect(() => {
    let isMounted = true;
    if (isLoadOImages) {
      get("routes/points/images/list", { routePointId: point.id })
        .then((list) => {
          if (isMounted) {
            setImages(list);
            setIsLoadOImages(false);
          }
        })
        .catch((status) => {
          snackbarHandler(getTranslation(`error${status}`));
          setIsLoadOImages(false);
          Log("Error on get routes/points/repairs/list" + status);
        });
    }

    return () => (isMounted = false);
  }, [isLoadOImages, point, snackbarHandler]);

  // get observation text
  useEffect(() => {
    let isMounted = true;
    if (isLoadObservationsText) {
      get("routes/points/observations/list", {
        routePointId: point.id,
      })
        .then((list) => {
          if (isMounted) {
            setObservationsText(list);
            setIsLoadObservationsText(false);
          }
        })
        .catch((status) => {
          snackbarHandler(getTranslation(`error${status}`));
          setIsLoadObservationsText(false);
          Log("Error on get routes/points/repairs/list" + status);
        });
    }

    return () => (isMounted = false);
  }, [isLoadObservationsText, point, snackbarHandler]);

  // get points repair list
  useEffect(() => {
    let isMounted = true;
    if (isLoadPointsRepairsList) {
      get("routes/points/repairs/list", { routePointId: point.id })
        .then((list) => {
          if (isMounted) {
            setPointsRepairsList(list);
            setIsLoadPointsRepairsList(false);
          }
        })
        .catch((status) => {
          snackbarHandler(getTranslation(`error${status}`));
          setIsLoadPointsRepairsList(false);
          Log("Error on get routes/points/repairs/list" + status);
        });
    }

    return () => (isMounted = false);
  }, [isLoadPointsRepairsList, point, snackbarHandler]);

  const removePointDateHandler = () => setRemoveRouteDate(true);
  const startedPointChangeHandler = useCallback((value) => {
    setStartedPoint(moment(value).format("YYYY-MM-DD"));
  }, []);
  const endedPointChangeHandler = useCallback((value) => {
    setEndedPoint(moment(value).format("YYYY-MM-DD"));
  }, []);
  const checkHiddenTimeline = useCallback((value, time) => {
    setHideTimeline((prev) => ({ ...prev, [time]: value }));
  }, []);

  const [isTitleShow, setIsTitleShow] = useState(true);
  const removeTitleHandler = () => setIsTitleShow(false);
  return (
    <>
      {point && (
        <DeviceInformationStyled className="page-break deviceInformation">
          <span className="title">
            {getTranslation("0086")}:{" "}
            {point.equipment &&
              point.equipment.model &&
              point.equipment.model.brand &&
              point.equipment.model.brand.name}
          </span>
          <span>
            {getTranslation("0085")}:{" "}
            {point.equipment &&
              point.equipment.model &&
              point.equipment.model.name}
          </span>
          <span>
            {getTranslation("0102")}:{" "}
            {point.equipment && point.equipment.serialNumber}
          </span>

          {point.equipment && point.equipment.address && (
            <span>
              {getTranslation("0110")}: {point.equipment.address}
            </span>
          )}

          {!removeRouteDate && (
            <span className="date">
              {getTranslation("0026")}:{" "}
              <span>
                <DatePickerHooksReport
                  value={startedPoint}
                  isEmpty={startedPoint === ""}
                  onChange={startedPointChangeHandler}
                />
              </span>
              , {getTranslation("0027")}:{" "}
              <span>
                <DatePickerHooksReport
                  value={endedPoint}
                  isEmpty={endedPoint === ""}
                  onChange={endedPointChangeHandler}
                />
              </span>
              <DeleteOutlineIcon
                className="remove hideInPDF"
                onClick={removePointDateHandler}
              />
            </span>
          )}

          {vehicle.length > 0 &&
            vehicle.map((vehicle) => (
              <span className="vehicle" key={vehicle.vehicle.id}>
                <b>{vehicle.vehicle.licensePlate}</b>
                <br />
                {getTranslation("0013")} {getTranslation("0177").toLowerCase()}:{" "}
                {vehicle.startKms}, {getTranslation("0015")}{" "}
                {getTranslation("0177").toLowerCase()}: {vehicle.endKms},{" "}
                {getTranslation("0180")}:{" "}
                {Number(vehicle.endKms) - Number(vehicle.startKms)}
              </span>
            ))}
        </DeviceInformationStyled>
      )}
      <DisplayObservationAndImages
        timeline="S"
        images={images}
        observationsText={observationsText}
        IsHidden={checkHiddenTimeline}
        hideTimeline={hideTimeline}
        HideTitle={removeTitleHandler}
        isTitleShow={isTitleShow}
      />
      <DisplayObservationAndImages
        timeline="M"
        images={images}
        observationsText={observationsText}
        IsHidden={checkHiddenTimeline}
        hideTimeline={hideTimeline}
        HideTitle={removeTitleHandler}
        isTitleShow={isTitleShow}
      />

      <DisplayObservationAndImages
        timeline="E"
        images={images}
        observationsText={observationsText}
        IsHidden={checkHiddenTimeline}
        hideTimeline={hideTimeline}
        HideTitle={removeTitleHandler}
        isTitleShow={isTitleShow}
      />

      {pointsRepairsList.length > 0 && (
        <RepairListStyled className="page-break deviceInformation">
          <span className="headline">{getTranslation("0095")}</span>
          {pointsRepairsList.map((repair) => (
            <RepairDetail key={repair.id} repair={repair} />
          ))}
          <span className="headline">{getTranslation("0088")}</span>
          <DeviceInformationStyled>
            <span className="title">{pointsRepairsList[0].account.name}</span>
            <span>{pointsRepairsList[0].account.email}</span>
          </DeviceInformationStyled>
        </RepairListStyled>
      )}
      <hr className="hideInPDF" />
    </>
  );
};

const RepairDetail = ({ repair }) => {
  const [removeRepairDate, setRemoveRepairDate] = useState(false);
  const [started, setStarted] = useState(repair.started ? repair.started : "");
  const [ended, setEnded] = useState(repair.ended ? repair.setEnded : "");
  const removeRepairDateHandler = () => setRemoveRepairDate(true);
  const startedChangeHandler = useCallback((value) => {
    setStarted(moment(value).format("YYYY-MM-DD"));
  }, []);
  const endedChangeHandler = useCallback((value) => {
    setEnded(moment(value).format("YYYY-MM-DD"));
  }, []);
  return (
    <DeviceInformationStyled>
      <span className="title">{repair.modelRepairType.name}</span>
      <span>{repair.modelRepairType.description}</span>
      {!removeRepairDate && (
        <span className="date">
          {getTranslation("0026")}:{" "}
          <span>
            <DatePickerHooksReport
              value={started}
              isEmpty={started === ""}
              onChange={startedChangeHandler}
            />
          </span>
          , {getTranslation("0027")}:{" "}
          <span>
            <DatePickerHooksReport
              value={ended}
              isEmpty={ended === ""}
              onChange={endedChangeHandler}
            />
          </span>
          <DeleteOutlineIcon
            className="remove hideInPDF"
            onClick={removeRepairDateHandler}
          />
        </span>
      )}
    </DeviceInformationStyled>
  );
};

const DisplayObservationAndImages = ({
  timeline,
  images,
  observationsText,
  IsHidden,
  hideTimeline,
  isTitleShow,
  HideTitle,
}) => {
  const [imagesToDisplay, setImagesToDisplay] = useState([]);
  const [filterImage, setFilterImage] = useState(true);
  const [breakClass, setBreakClass] = useState(false);

  // filter images
  useEffect(() => {
    if (filterImage && images.length > 0) {
      let image = images.filter((item) => item.timeline === timeline);
      setImagesToDisplay(image);
      setFilterImage(false);
    }
  }, [timeline, images, filterImage]);

  // remove images handler
  const hideImagesClickHandler = (id) => {
    let newImageList = imagesToDisplay.filter((item) => item.id !== id);
    setImagesToDisplay(newImageList);
  };

  // observation
  const [filterObservation, setFilterObservation] = useState(true);
  const [textToDisplay, setTextToDisplay] = useState("");
  const observationsTextChangeHandler = (event) =>
    setTextToDisplay(event.target.value);

  useEffect(() => {
    if (filterObservation && observationsText.length > 0) {
      let defaultText = "";
      if (observationsText.length > 0) {
        let text = observationsText.filter(
          (item) => item.timeline === timeline
        );
        if (text.length > 0) {
          defaultText = text[0].observations;
        }
      }
      setTextToDisplay(defaultText);
      setFilterObservation(false);
    }
  }, [timeline, observationsText, filterObservation]);

  const [isHide, setIsHide] = useState(false);
  useEffect(() => {
    let hide =
      imagesToDisplay.length > 0 ? false : textToDisplay ? false : true;
    IsHidden(hide, timeline);
    setIsHide(hide);
  }, [imagesToDisplay, textToDisplay, timeline, IsHidden]);
  useEffect(() => {
    let breakClass = "";
    if (timeline === "S") {
      breakClass = false;
    } else if (timeline === "M") {
      if (hideTimeline["S"]) {
        breakClass = false;
      } else {
        breakClass = true;
      }
    } else {
      if (hideTimeline["S"]) {
        if (hideTimeline["M"]) {
          breakClass = false;
        } else {
          breakClass = true;
        }
      } else {
        breakClass = true;
      }
    }
    setBreakClass(breakClass);
  }, [timeline, hideTimeline]);

  return (
    <TimelineStyled
      className={`${isHide && "hideInPDF"} ${
        breakClass && "page-break"
      } deviceInformation`}
    >
      {isTitleShow && (
        <span
          className={`headline`}
          data-translate={`${
            timeline === "S" ? "0013" : timeline === "M" ? "0014" : "0015"
          }`}
        >
          {timeline === "S" && getTranslation("0013")}
          {timeline === "M" && getTranslation("0014")}
          {timeline === "E" && getTranslation("0015")}
          <DeleteOutlineIcon className="remove hideInPDF" onClick={HideTitle} />
        </span>
      )}
      {imagesToDisplay.length > 0 && (
        <ImageDisplayStyled>
          {imagesToDisplay.length > 0 &&
            imagesToDisplay.map((image) => (
              <div key={image.id}>
                <div
                  className="removeImage"
                  onClick={() => hideImagesClickHandler(image.id)}
                >
                  <DeleteOutlineIcon className="hideInPDF" />
                </div>
                <img src={image.report} alt={`Report-${timeline}`} />
              </div>
            ))}
        </ImageDisplayStyled>
      )}

      <ObservationsTextStyled>
        <span
          data-translate="0016"
          className={`${!textToDisplay && "hideInPDF"}`}
        >
          {getTranslation("0016")}
        </span>
        <textarea
          className={`${!textToDisplay && "hideInPDF"}`}
          value={textToDisplay}
          onChange={observationsTextChangeHandler}
        />
      </ObservationsTextStyled>
    </TimelineStyled>
  );
};

const RepairListStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
    padding: ${current.gMD} 0 0 0;
      .headline{
        padding: 0 ${current.gXL};
        ${current.fLG};
        font-family: "os-bold"!important; 
    }
  `;
  }}
`;

const TimelineStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
      padding:${current.gMD} ${current.gXL};
      .headline{
        display:flex;
        margin-bottom:${current.gMD};
        ${current.fMD};
        font-family: "os-regular"!important; 
      }
    `;
  }}
`;

const ObservationsTextStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
        margin:${current.gXL} 0;
          >span{
            ${current.fDF};
            font-family: "os-regular"!important; 
            display:flex;
          }
          >textarea{
            margin-top:${current.gMD};
            ${current.fSM};
            font-family: "os-regular"!important;
            width:100%;
            resize: vertical;
            border:none!important;
            height:438px!important;
          }
        `;
  }}
`;

const DeviceInformationStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
            padding:${current.gMD} ${current.gXL};
            display:flex;
            flex-direction:column;
           
                >span{
                    ${current.fSM};
                    margin-bottom:${current.gMD};
                    font-family: "os-regular"!important;
                }
                >span.title{
                    ${current.fLG};
                    font-family: "os-bold"!important;
                    margin-bottom:0;
                }
                >span.vehicle{
                  align-items:center;
                  color:rgba(${current.black},0.4);
                  font-family: "os-regular"!important;
                  >b{
                    color:rgba(${current.black},1);
                    ${current.fMD};
                    font-family: "os-bold"!important;
                  }
                }
                >span.date{
                  display:flex;
                  align-items:center;
                  color:rgba(${current.black},0.4);
                  font-family: "os-regular"!important;
                  position: relative;
                  .isEmpty{
                    position: absolute;
                    font-size: 15px;
                    letter-spacing: 1px;
                    margin-left: 5px;
                  }
                }
        `;
  }}
`;
const ImageDisplayStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
    display:flex;
    flex-wrap:wrap;
    margin-bottom:${current.gXL};
        >div{
            display:flex;
            flex-direction:column;
            width:200px;
            max-width:200px;
            margin-right:${current.gXL};
            ${current.fMD};
            margin-bottom:${current.gMD};
            position:relative;
            align-items: center;
            justify-content: center;

            .removeImage{
              position:absolute;
              width:100%;
              height:100%;
              display:none;
              background:rgba(${current.red}, 0.8);
              cursor:pointer;
              >svg{
                width:30px;
                height:30px;
                color:rgb(${current.white});
              }
            }
            >img{
                width:200px;
                height:auto;
                overflow:hidden;
            }
            :hover{
              .removeImage{
                display:flex;
                align-items: center;
                justify-content: center;
              }
            }
        }
        >div:last-child{
            margin-right:0;
        }
    `;
  }}
`;
